import(/* webpackMode: "eager", webpackExports: ["QRCode"] */ "/home/runner/work/mappito/mappito/site/components/QRCode.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/mappito/mappito/site/node_modules/.pnpm/next@15.5.12_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_react-_ae047c41b6feb389a77e083f849ed169/node_modules/next/dist/client/app-dir/link.js");
